import React from "react";
import "../../styles/footer.css";
const Footer = () => {
  return (
    <footer className="footer">
      Made by <a href="https://github.com/Ali-Jahankah"> Ali Jahankah</a>
    </footer>
  );
};

export default Footer;
